import React, {
  useState,
  forwardRef,
  ChangeEvent,
  FocusEventHandler,
} from 'react';

interface InputFieldProps {
  maxLength?: number;
  name: string;
  dataName: string;
  pattern?: string;
  placeholder: string;
  type: string;
  id: string;
  minLength?: number;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void; // ✅ Asegurar tipo correcto
}

const InputField = forwardRef<HTMLInputElement, InputFieldProps>(
  (
    {
      maxLength = 256,
      name,
      dataName,
      pattern = '^[a-zA-Z0-9]+$',
      placeholder,
      type,
      id,
      minLength = 3,
      onBlur,
      onChange, // ✅ Extraer correctamente
    },
    ref
  ) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      // Si es para contraseñas, permitir caracteres especiales
      const isPasswordField = pattern.includes(String.raw`\-+=|\\(){}`);
      const regex = isPasswordField ? /^[a-zA-Z0-9\-+=|\\(){}[\]:;*.]*$/ : /^[a-zA-Z0-9]*$/;
      const replacePattern = isPasswordField ? /[^a-zA-Z0-9\-+=|\\(){}[\]:;*.]/g : /[^a-zA-Z0-9]/g;
      
      let newValue = event.target.value;

      if (!regex.test(newValue)) {
        newValue = newValue.replace(replacePattern, '');
        event.target.value = newValue; // importante si no usas useState
      }

      onChange?.(event);
    };

    return (
      <input
        className="input w-input"
        maxLength={maxLength}
        name={name}
        data-name={dataName}
        pattern={pattern}
        placeholder={placeholder}
        type={type}
        id={id}
        onChange={onChange ?? handleChange} // ✅ Si no pasas uno, usa el interno
        onBlur={onBlur}
        minLength={minLength}
        ref={ref}
        onKeyDown={(e) => {
          // Determinar si es campo de contraseña
          const isPasswordField = pattern.includes(String.raw`\-+=|\\(){}`);
          const allowedChars = isPasswordField ? /[a-zA-Z0-9\-+=|\\(){}[\]:;*.]/ : /[a-zA-Z0-9]/;
          
          // Permite caracteres válidos y teclas de control
          if (
            !allowedChars.test(e.key) &&
            !['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(
              e.key
            )
          ) {
            e.preventDefault();
          }
        }}
      />
    );
  }
);

export default InputField;
